'use client';

import { Skeleton } from '@mui/material';
import clsx from 'clsx';
import Image from 'next/image';
import { ReactEventHandler, useCallback, useEffect, useState } from 'react';

import { useQueryConfigs } from '@/query/hooks/use-query-configs';
import { generatePublicImageUrl } from '@/utilities/generate-image-url';

const DEFAULT_LOGO = '/images/logo-epos.svg';

const ConfigLogo: React.FC<{ subdomain: string }> = ({ subdomain }) => {
  const { data, isLoading } = useQueryConfigs();
  const [hasError, setHasError] = useState(false);
  const [isLoadingImg, setIsLoadingImg] = useState(true);

  const imageUrl = data?.id
    ? generatePublicImageUrl(data.id, subdomain, data.updatedAt)
    : DEFAULT_LOGO;

  const effectiveSrc = hasError ? DEFAULT_LOGO : imageUrl;

  useEffect(() => {
    setHasError(false);
    setIsLoadingImg(true);
  }, [imageUrl]);

  const showSkeleton = isLoading || (data?.id && !hasError && isLoadingImg);

  const errorHandler = useCallback<ReactEventHandler<HTMLImageElement>>(() => {
    setHasError(true);
    setIsLoadingImg(false);
  }, []);

  return (
    <div className='relative h-[50px] w-fit'>
      <Image
        src={effectiveSrc}
        alt={subdomain}
        className={clsx('h-[50px] w-fit object-contain md:self-start', { 'opacity-0': showSkeleton })}
        width={255}
        height={86}
        priority
        quality={100}
        onLoad={() => setIsLoadingImg(false)}
        onError={errorHandler}
      />
      {showSkeleton && (
        <Skeleton
          variant='rectangular'
          animation='wave'
          width={148}
          height={50}
          className='!absolute !top-0 !left-0'
        />
      )}
    </div>
  );
};

export default ConfigLogo;
